import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, throwError } from 'rxjs';
import { IGenericResponse } from 'src/app/common/interface/generic-response.interface';
import { BaseHttpService } from './base-http/base-http.service';
import { SessionStorageService } from './storage/session-storage/session-storage.service';
import { CONTROLS_ENABLED } from '../constants/test-cases.constants';
import {
  GET_USERS_REPORT_URL,
  GET_PROJECT_REPORT_URL,
  GENERATE_GENAI_REPORT_URL,
  AUTONOMOUS_TESTING_PATH,
} from 'src/app/components/platform-admin/common/platform-admin.constants';
import { HttpParams } from '@angular/common/http';
import { ITestCasesFilter } from 'src/app/common/interface/test-case-interface';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  private keyCode: BehaviorSubject<number>;
  private hideNavbar: BehaviorSubject<boolean>;
  private testCaseType: BehaviorSubject<string>;
  private fromEditPopUp: BehaviorSubject<string>;
  private reloadProjectDetailsPostImport : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public reloadProjectDetailsPostImport$: Observable<boolean> = this.reloadProjectDetailsPostImport.asObservable();
  private linkedUserStoryDataValuesSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public linkedUserStoryDataValues$: Observable<any[]> = this.linkedUserStoryDataValuesSubject.asObservable();
  private linkedUserStoryDevObjectsSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public linkedUserStoryDevObjectValues$: Observable<any[]> = this.linkedUserStoryDevObjectsSubject.asObservable();
  private checkLibraryWriteAccess: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public libraryWriteaccess: Observable<boolean> = this.checkLibraryWriteAccess.asObservable();
  private applicationVersionDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public applicationVersionData: Observable<any> = this.applicationVersionDataSubject.asObservable();
  private selectedtAppVersionIdSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public selectedtAppVersionId: Observable<any> = this.selectedtAppVersionIdSubject.asObservable();
  private testCaseExecutionStatus: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public testCaseDropdownStatus: Observable<any> = this.testCaseExecutionStatus.asObservable();
  private editTestCaseDiagram: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public editTestCaseDiagramData: Observable<any> = this.editTestCaseDiagram.asObservable();
  private genAIEnabledSubject = new BehaviorSubject<boolean>(false);
  public genAIEnabled$ = this.genAIEnabledSubject.asObservable();
  private updateTestCaseData: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private testCaseIdSubject = new BehaviorSubject<string | null>(null);
  public testCaseId$ = this.testCaseIdSubject.asObservable();
  private testCaseFilter: BehaviorSubject<ITestCasesFilter['preferences']> = new BehaviorSubject<ITestCasesFilter['preferences']>(null);
  private projectIdSource = new BehaviorSubject<string | null>(null);
  private toscaEnabledSubject = new BehaviorSubject<boolean>(false);
  private controlsEnabledSubject = new BehaviorSubject<boolean>(false);
  public controlsEnabled$ = this.controlsEnabledSubject.asObservable();
  
  projectId$ = this.projectIdSource.asObservable();
  tabSelectedIndex:any;
  userStoryData:any;
  isButtonDisabled:boolean = false;
  projectTaxonomy:any;
  selectedAppVersionId: string;
  projectAppversionId:string;
  isUnmatched:boolean = true;
  backClicked:boolean = false;  
  projectTaxonomyStatus:any;
  popupData:any;
  constructor(
    private readonly httpService: BaseHttpService,
    private readonly sessionStorage: SessionStorageService
  ) {
    this.keyCode = new BehaviorSubject<number>(null);
    this.hideNavbar= new BehaviorSubject<boolean>(false)
    this.testCaseType = new BehaviorSubject<string>("");
    this.fromEditPopUp = new BehaviorSubject<string>("");
    // Seeding the controls flag value. Load the saved value from session storage on app start so subscribers get the correct value.
    const storedValue = this.sessionStorage.getValue(CONTROLS_ENABLED) ?? false;
    this.controlsEnabledSubject.next(storedValue);
  }
  setControlsEnabled(value: boolean): void {
    this.controlsEnabledSubject.next(value);
  }
  setTestCaseExecutionStatus(value: any) {
    this.testCaseExecutionStatus.next(value);
  }
  getTestCaseExecutionStatus(): any {
    return this.testCaseExecutionStatus.value;
  }
  setLibraryWriteAccess(value: boolean) {
    this.checkLibraryWriteAccess.next(value);
  }
  getLibraryWriteAccess(): boolean {
    return this.checkLibraryWriteAccess.value;
  }
  setApplicationVersionData(value: any) :void{
    this.applicationVersionDataSubject.next(value);
  }
  getApplicationVersionData(): any {
    return this.applicationVersionDataSubject.value;
  }
  setLinkedUserStoryDataValues(value: any[]): void {
    this.linkedUserStoryDataValuesSubject.next(value);
  }

  getLinkedUserStoryDataValues(): any[] {
    return this.linkedUserStoryDataValuesSubject.value;
  }
 setUpdatedtestcaseData(value: any) {
    this.updateTestCaseData.next(value);
  }
  getUpdatedtestcaseData() {
    return this.updateTestCaseData.asObservable();
  }
  setlinkedUserStoryDevObjectValues(value: any[]): void {
    this.linkedUserStoryDevObjectsSubject.next(value);
  }

  setProjectDetailsReloadPostImport(value: boolean) {
    this.reloadProjectDetailsPostImport.next(value);
  }
  
  getlinkedUserStoryDevObjectValues(): any[] {
    return this.linkedUserStoryDevObjectsSubject.value;
  }

  setEditTestCaseDiagramData(value: any) {
    this.editTestCaseDiagram.next(value);
  }

  setTestCaseId(testCaseId: string): void {
    this.testCaseIdSubject.next(testCaseId);
  }

  setToscaEnabled = (isEnabled: boolean) =>
    this.toscaEnabledSubject.next(isEnabled);

  getToscaEnabled = (): Observable<boolean> => this.toscaEnabledSubject.asObservable();

  downloadFile(data, filename?: string) {
    const fileName = filename ?? data.headers
      .get('content-disposition')
      .split(';')[1]
      .split('filename')[1]
      .split('=')[1]
      .trim()
      .split('"')
      .join('');
    const type = data.headers.get('content-type');
    const blob = new Blob([data.body], { type });
    FileSaver.saveAs(blob, fileName);
  }

  /**
   * DownloadUserReport: method is used to download user report based user search
   *
   * @param {string} search
   */
  downloadUserReport = (search: string) => {
    return this.httpService
      .getBlobFile(`${GET_USERS_REPORT_URL}?search=${search}`)
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        }),
        catchError((error) => throwError(() => error))
      );
  };

  /**
   * DownloadProjectReport: method is used to download project report based
   * on user search
   *
   * @param {string} search
   * @param {string} queryParams
   */
  downloadProjectReport = (search: string, queryParams: string) => {
    return this.httpService
      .getBlobFile(`${GET_PROJECT_REPORT_URL}?search=${search}&${queryParams}`)
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        }),
        catchError((error) => throwError(() => error))
      );
  };

  /**
   * generateGenAIReport: method is used to generate genai report for projects
   * @param search - Optional search for projectName.
   * @param packageId - Optional list of packageId.
   * @param genAI - Optional list of genAI flag.
   * @param criticalPath - Optional list of criticalPath.
   * @param projectStatus - Optional list of projectStatus.
   */
  generateGenAIReport = (
    search?: string,
    packageId?: string[],
    genAI?: boolean[],
    criticalPath?: string[],
    projectStatus?: string[]
  ) => {
    const requestBody = {
      search: search || '',
      packageId: packageId || [],
      genAI: genAI || [],
      criticalPath: criticalPath || [],
      projectStatus: projectStatus || [],
    };
    return this.httpService
      .post(
        `${AUTONOMOUS_TESTING_PATH}/${GENERATE_GENAI_REPORT_URL}`,
        requestBody
      )
      .pipe(
        map((res: IGenericResponse) => {
          if (res?.status === 200) {
            return res.data;
          }
        }),
        catchError((error) => {
          return throwError(() => error);
        })
      );
  };

  public getProjectSettings(projectId) {
    return this.httpService.get(`project/${projectId}/settings`)?.pipe(map((res: IGenericResponse) => {
      if(res?.status == 200) {
        return res.data
      }
    }),
    catchError(error => {
      return throwError(() => error)
    }));
  }

  public getWebSearchFeatureFlag(projectId: string) {
    return this.httpService.get(`autonomous-testing/get-feature-flag?projectId=${projectId}`)?.pipe(
      map((res: IGenericResponse) => {
        if (res?.status === 200) {
          return res.data;
        }
      }),
      catchError(error => {
        return throwError(() => error);
      })
    );
  }
    

  setKeyCode(code) {
    this.keyCode.next(code);
  }

  getKeyCode() {
    return this.keyCode.asObservable();
  }

  setHideNavbar(flag) {
    this.hideNavbar.next(flag);
  }

  getHideNavbar() {
    return this.hideNavbar.asObservable();
  }

  setTestCaseType(val:string) {
    this.testCaseType.next(val);
  }
  getTestCaseType() {
    return this.testCaseType.asObservable();
  }

  setfromEditPopUp(val:string) {
    this.fromEditPopUp.next(val);
  }
  getfromEditPopUp() {
    return this.fromEditPopUp.asObservable();
  }

  disableLinkedDevObjects(userStoryId: string) {
    const userStory = this.userStoryData.find(x => x.cc_id === userStoryId);
    this.isButtonDisabled = userStory && userStory.devObjectids?.length <= 0 ? true : false;
  }

  /**
   * GetTrackProject: This is a GET API call that is used to track the last activity of a project.
   * 
   * @param projectId String 
   * @param skipLoader Boolean
   * @returns Object
   */
  public getTrackProject(projectId: string, skipLoader: boolean = false) {
    return this.httpService
      .get(`project/track/${projectId}`, skipLoader)
      .pipe(
        map((res: IGenericResponse) => {
          if (res?.status === 200) {
            return res;
          }
        }),
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }

    public getProjectTags(projectId: string, skipLoader: boolean = false) {
    if (!projectId) return of([]);
    return this.httpService
      .get(`project-test-cases/tags/${projectId}`, skipLoader)
      .pipe(
        map((res: IGenericResponse) => {
          if (res?.status === 200) {
            return res.data;
          }
        }),
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }

  /**
   * Fetches terms and conditions for a specific project and user.
   *
   * Sends a GET request to retrieve the GenAI terms and conditions associated 
   *
   * @param {string} projectId - The ID of the project to fetch terms for.
   * @returns {Observable<any>} An observable containing the terms and conditions data.
   */
  getUserGenAITC = (projectId: string): Observable<any> => {
    return this.httpService
      .get(`autonomous-testing/terms-and-conditions?projectId=${projectId}`)
      .pipe(
        map((res: IGenericResponse) => {
          if (res?.status === 200) {
            return res.data;
          }
        }),
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }

  /**
   * Sends a request to accept the terms and conditions for a specific project.
   *
   * Creates a request body with the project ID and and save the terms as accepted.
   *
   * @param {string} projectId - The ID of the project for which terms and conditions are to be accepted.
   * @returns {Observable<any>} An observable containing the response data when the request is successful.
   */
  acceptTermsAndConditions = (projectId: string) => {
    const requestBody = { projectId };

    return this.httpService.post(`autonomous-testing/terms-and-conditions`, requestBody).pipe(
      map((res: IGenericResponse) => {
        if (res?.status === 200) {
          return res.data;
        }
      }),
      catchError(error => {
        return throwError(() => error);
      })
    );
  }

  setGenAIEnabled(isEnabled: boolean) {
    this.genAIEnabledSubject.next(isEnabled);
  }

  /**
   * Fetches the Test AI Recorder versions by hitting the GET API.
   *
   * @returns An observable containing the response data when the request is successful.
   */
  getTestAiRecorderVersions = () => {
    return this.httpService.get(`test-case/objectRecorder/utility`).pipe(
      map((res: IGenericResponse) => {
        if (res?.status === 200) {
          return res.data;
        }
      }),
      catchError(error => {
        return throwError(() => error);
      })
    );
  };

  /**
   * Fetches the details of a specific Test AI Recorder version by hitting the GET API.
   *
   * @param {string} version - The version of the Test AI Recorder to fetch details for.
   * @returns An observable containing the response data when the request is successful.
   */
  getTestAiRecorderVersionDetails = (version: string) => {
    return this.httpService.get(`test-case/objectRecorder/utility/${version}`).pipe(
      map((res: IGenericResponse) => {
        if (res?.status === 200) {
          return res.data;
        }
      }),
      catchError(error => {
        return throwError(() => error);
      })
    );
  }

  /**
   * Retrieves the status of a specific feature for a given project.
   *
   * Sends a GET request to the feature-status API endpoint to determine whether
   * the specified feature is enabled or available for the provided project.
   *
   * @param {string} projectId - The ID of the project to check the feature status for.
   * @param {string} feature - The name of the feature whose status is to be checked.
   * @returns {Observable<boolean>} An observable emitting the status of the feature (true if enabled, false otherwise).
   */
  getProjectFeatureStatus = (
    projectId: string,
    feature: string
  ): Observable<boolean> => {
    return this.httpService
      .get(
        `${AUTONOMOUS_TESTING_PATH}/project/feature-status?projectId=${projectId}&feature=${feature}`
      )
      .pipe(
        map((res: IGenericResponse) => {
          if (res?.status == 200) {
            return res.data;
          }
        }),
        catchError((error) => {
          return throwError(() => error);
        })
      );
  };

  /**
   * Updates the current test case filter preferences.
   *
   * @param {ITestCasesFilter['preferences']} value - The new filter preferences to set.
   */
  setTestCaseFilter = (value: ITestCasesFilter['preferences']) =>
    this.testCaseFilter.next(value);

  /**
   * Retrieves the current test case filter preferences.
   *
   * @returns {ITestCasesFilter['preferences']} The current filter preferences.
   */
  getTestCaseFilter = (): ITestCasesFilter['preferences'] =>
    this.testCaseFilter.value;

  /**
   * Sets the current project ID.
   * Updates the internal projectIdSource BehaviorSubject with the provided project ID.
   *
   * @param {string} id - The ID of the project to set as current.
   */
  setProjectId = (id: string) => this.projectIdSource.next(id);

  /**
   * Retrieves the current project ID.
   *
   * @returns {string | null} The current project ID, or null if not set.
   */
  getProjectId = (): string | null => this.projectIdSource.getValue();

  /**
   * Fetches available reasoning parameters/options for a given project.
   * 
   * @param projectId Project identifier used to scope reasoning options.
   * @returns Observable emitting reasoning options payload (as returned by API) or errors.
   */
  getReasoningOptions = (projectId?: string): Observable<boolean> => {
    let url = `${AUTONOMOUS_TESTING_PATH}/get-reasoning-parameters`;

    if (projectId !== undefined && projectId !== '')
      url += `?projectId=${encodeURIComponent(projectId)}`;

    return this.httpService.get(url).pipe(
      map((res: IGenericResponse) => (res?.status === 200 ? res.data : false)),
      catchError((error) => throwError(() => error))
    );
  };

  /**
   * Gets the status of the Tosca feature for a specific project.
   * 
   * @param projectId - The ID of the project to check Tosca feature status for.
   * @returns Observable emitting Tosca feature status (true if enabled, false otherwise) or errors.
   */
  getToscaFeatureStatus(projectId) {
    return this.httpService
      .get(`project-test-cases/tosca/tosca-feature-flag/${projectId}`)
      ?.pipe(
        map((res: IGenericResponse) => {
          if (res?.status == 200) {
            return res.data;
          }
        }),
        catchError((error) => {
          return throwError(() => error);
        }),
      );
  }
}
